import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { db } from "../firebase/firebase";

import {
    doc,
    getDoc,
    setDoc,
} from "firebase/firestore";
import { BsClipboardCheckFill } from "react-icons/bs";

export default function CoursesJSON() {

    const [bulkOfferPrice, setBulkOfferPrice] = useState("");
    const [bulkOriginalPrice, setBulkOriginalPrice] = useState("");
    const [tierEditing, setTierEditing] = useState({});

    const handleTierUpdate = async (
        courseIndex,
        tierIndex
    ) => {
        const updated = [...courses];

        updated[courseIndex].tiers[tierIndex].price =
            tierEditing[`${courseIndex}-${tierIndex}`];

        await saveCourses(updated);

        alert("Tier updated ✅");
    };

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [courses, setCourses] = useState([]);

    const [newCourseJson, setNewCourseJson] =
        useState("");

    const [editingIndex, setEditingIndex] =
        useState(null);

    const [editingValue, setEditingValue] =
        useState("");

    const [jsonEditingIndex, setJsonEditingIndex] = useState(null);

    const [jsonEditingValue, setJsonEditingValue] = useState("");

    /* ---------------- FETCH ---------------- */
    useEffect(() => {

        fetchCourses();

    }, []);

    const fetchCourses = async () => {

        try {

            const snap = await getDoc(
                doc(db, "course", "allCourses")
            );

            if (snap.exists()) {

                setCourses(
                    snap.data().courses || []
                );
            }

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);
        }
    };

    /* ---------------- SAVE ---------------- */
    const saveCourses = async (
        updatedCourses
    ) => {

        try {

            await setDoc(
                doc(
                    db,
                    "course",
                    "allCourses"
                ),
                {
                    courses: updatedCourses,
                }
            );

            setCourses(updatedCourses);

        } catch (err) {

            console.error(err);

            alert("Failed ❌");
        }
    };

    /* ---------------- ADD COURSE ---------------- */
    const handleAddCourse = async () => {

        try {

            if (!newCourseJson.trim()) {

                return alert(
                    "Paste course JSON"
                );
            }

            const parsedCourse =
                JSON.parse(
                    newCourseJson
                );

            if (
                !parsedCourse.title
            ) {

                return alert(
                    "Title missing"
                );
            }

            /* AUTO ID */
            if (!parsedCourse.id) {

                parsedCourse.id =
                    parsedCourse.title
                        .toLowerCase()
                        .replace(
                            /\s+/g,
                            "-"
                        );
            }

            /* AUTO SLUG */
            if (
                !parsedCourse.slug
            ) {

                parsedCourse.slug =
                    parsedCourse.title
                        .toLowerCase()
                        .replace(
                            /\s+/g,
                            "-"
                        );
            }

            const alreadyExists =
                courses.some(
                    (c) =>
                        c.id ===
                        parsedCourse.id
                );

            if (alreadyExists) {

                return alert(
                    "Course ID already exists"
                );
            }

            /* FINAL STRUCTURE */
            // const finalCourse = {

            //     id:
            //         parsedCourse.id ||
            //         "",

            //     title:
            //         parsedCourse.title ||
            //         "",

            //     slug:
            //         parsedCourse.slug ||
            //         "",

            //     shortDescription:
            //         parsedCourse.shortDescription ||
            //         "",

            //     category:
            //         parsedCourse.category ||
            //         "",

            //     duration:
            //         parsedCourse.duration ||
            //         "",

            //     isPopular:
            //         parsedCourse.isPopular ||
            //         false,

            //     seo: {
            //         seoTitle:
            //             parsedCourse
            //                 .seo
            //                 ?.seoTitle ||
            //             "",

            //         seoDescription:
            //             parsedCourse
            //                 .seo
            //                 ?.seoDescription ||
            //             "",

            //         seoKeywords:
            //             parsedCourse
            //                 .seo
            //                 ?.seoKeywords ||
            //             [],
            //     },

            //     media: {
            //         banner:
            //             parsedCourse
            //                 .media
            //                 ?.banner ||
            //             "",

            //         thumbnail:
            //             parsedCourse
            //                 .media
            //                 ?.thumbnail ||
            //             "",

            //         logo:
            //             parsedCourse
            //                 .media
            //                 ?.logo ||
            //             "",

            //         img:
            //             parsedCourse
            //                 .media
            //                 ?.img ||
            //             "",
            //     },

            //     outcomes:
            //         parsedCourse.outcomes ||
            //         [],

            //     faqs:
            //         parsedCourse.faqs ||
            //         [],

            //     testimonials:
            //         parsedCourse.testimonials ||
            //         [],

            //     projects: {
            //         core:
            //             parsedCourse
            //                 .projects
            //                 ?.core ||
            //             [],

            //         jobReady:
            //             parsedCourse
            //                 .projects
            //                 ?.jobReady ||
            //             [],

            //         pro:
            //             parsedCourse
            //                 .projects
            //                 ?.pro ||
            //             [],
            //     },

            //     tiers:
            //         parsedCourse.tiers ||
            //         [],
            // };

            const finalCourse = {
                id: parsedCourse.id || "",

                title: parsedCourse.title || "",

                slug: parsedCourse.slug || "",

                shortDescription:
                    parsedCourse.shortDescription || "",

                category:
                    parsedCourse.category || "",

                duration:
                    parsedCourse.duration || "",

                isPopular:
                    parsedCourse.isPopular || false,

                seo: {
                    seoTitle:
                        parsedCourse.seo?.seoTitle || "",

                    seoDescription:
                        parsedCourse.seo?.seoDescription || "",

                    seoKeywords:
                        parsedCourse.seo?.seoKeywords || [],
                },

                media: {
                    banner:
                        parsedCourse.media?.banner || "",

                    thumbnail:
                        parsedCourse.media?.thumbnail || "",

                    logo:
                        parsedCourse.media?.logo || "",

                    img:
                        parsedCourse.media?.img || "",
                },

                overview: {
                    description:
                        parsedCourse.overview?.description || ""
                },

                outcomes:
                    parsedCourse.outcomes || [],

                toolsMastery:
                    parsedCourse.toolsMastery || [],

                whatYouBuild:
                    parsedCourse.whatYouBuild || [],

                skillsYouGain:
                    parsedCourse.skillsYouGain || [],

                careerOpportunities:
                    parsedCourse.careerOpportunities || [],

                whoShouldJoin:
                    parsedCourse.whoShouldJoin || [],

                marketRelevance: {
                    title:
                        parsedCourse.marketRelevance?.title || "",

                    points:
                        parsedCourse.marketRelevance?.points || [],
                },

                gallery:
                    parsedCourse.gallery || [],

                certificate: {
                    title:
                        parsedCourse.certificate?.title || "",

                    preview:
                        parsedCourse.certificate?.preview || "",
                },

                stats: {
                    studentsTrained:
                        parsedCourse.stats?.studentsTrained || "",

                    projectsCompleted:
                        parsedCourse.stats?.projectsCompleted || "",

                    successRate:
                        parsedCourse.stats?.successRate || "",

                    placementSupport:
                        parsedCourse.stats?.placementSupport || "",
                },

                relatedCourses:
                    parsedCourse.relatedCourses || [],

                faqs:
                    parsedCourse.faqs || [],

                testimonials:
                    parsedCourse.testimonials || [],

                projects: {
                    core:
                        parsedCourse.projects?.core || [],

                    jobReady:
                        parsedCourse.projects?.jobReady || [],

                    pro:
                        parsedCourse.projects?.pro || [],
                },

                tiers:
                    parsedCourse.tiers || [],
            };


            const updated = [
                ...courses,
                finalCourse,
            ];

            await saveCourses(updated);

            setNewCourseJson("");

            alert(
                "Course Added ✅"
            );

        } catch (err) {

            console.error(err);

            alert(
                "Invalid JSON ❌"
            );
        }
    };

    /* ---------------- DELETE ---------------- */
    const handleDelete = async (
        index
    ) => {

        const confirmDelete =
            window.confirm(
                "Delete this course?"
            );

        if (!confirmDelete) return;

        const updated =
            courses.filter(
                (_, i) =>
                    i !== index
            );

        await saveCourses(updated);
    };

    /* ---------------- EDIT ---------------- */
    const handleEdit = (
        index,
        value
    ) => {

        setEditingIndex(index);

        setEditingValue(value);
    };


    const handleJsonEdit = (index, course) => {
        setJsonEditingIndex(index);

        setJsonEditingValue(
            JSON.stringify(course, null, 2)
        );
    };


    const handleJsonUpdate = async (index) => {
        try {
            const parsedCourse =
                JSON.parse(jsonEditingValue);

            const updated = [...courses];

            updated[index] = parsedCourse;

            await saveCourses(updated);

            setJsonEditingIndex(null);
            setJsonEditingValue("");

            alert("JSON Updated ✅");

        } catch (err) {
            console.error(err);
            alert("Invalid JSON ❌");
        }
    };

    /* ---------------- UPDATE ---------------- */
    const handleUpdate = async (
        index
    ) => {

        if (
            !editingValue.trim()
        ) {

            return alert(
                "Course name required"
            );
        }

        const updated = [
            ...courses,
        ];

        updated[index] = {
            ...updated[index],

            title:
                editingValue.trim(),
        };

        await saveCourses(updated);

        setEditingIndex(null);

        setEditingValue("");
    };

    if (loading) {

        return (
            <div className="text-white">
                Loading...
            </div>
        );
    }

    /* ---------------- EXPORT JSON ---------------- */
    const handleExportJSON = () => {
        const jsonData = JSON.stringify(courses, null, 2);

        const blob = new Blob([jsonData], {
            type: "application/json",
        });

        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "courses.json";
        a.click();

        URL.revokeObjectURL(url);

        alert("JSON Exported ✅");
    };

    /* ---------------- COPY JSON ---------------- */
    const handleCopyJSON = async () => {
        try {
            const jsonData = JSON.stringify(courses, null, 2);

            await navigator.clipboard.writeText(jsonData);

            alert("Copied to clipboard ✅");
        } catch (err) {
            console.error(err);
            alert("Copy failed ❌");
        }
    };

    const handleCopyCourseJSON = async (course) => {
        try {
            await navigator.clipboard.writeText(
                JSON.stringify(course, null, 2)
            );

            alert(`${course.title} copied ✅`);
        } catch (err) {
            console.error(err);
            alert("Copy failed ❌");
        }
    };

    return (

        <div className="text-white">

            {/* HEADER */}
            <div className="flex justify-between items-center mb-8">

                <div>

                    <h1 className="text-3xl font-bold text-orange-500">
                        Courses
                    </h1>

                    <p className="text-slate-400 mt-1">
                        Manage all
                        institute
                        courses
                    </p>

                </div>

                {/* <button
                    onClick={() =>
                        navigate(-1)
                    }
                    className="bg-white/10 hover:bg-white/20 transition-all px-4 py-2 rounded-lg"
                >
                    Back
                </button> */}

                <div className="flex gap-3">

                    <button
                        onClick={handleExportJSON}
                        className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg"
                    >
                        Export JSON
                    </button>

                    <button
                        onClick={handleCopyJSON}
                        className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg"
                    >
                        Copy JSON
                    </button>

                    <button
                        onClick={() => navigate(-1)}
                        className="bg-white/10 hover:bg-white/20 transition-all px-4 py-2 rounded-lg"
                    >
                        Back
                    </button>

                </div>

            </div>

            {/* ADD COURSE */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-5">

                    <div>

                        <h2 className="text-xl font-semibold">
                            Paste Course
                            JSON
                        </h2>

                        <p className="text-slate-400 text-sm mt-1">
                            Paste full
                            course
                            array
                            object
                            here
                        </p>

                    </div>

                </div>

                <textarea
                    rows={18}
                    value={
                        newCourseJson
                    }
                    onChange={(e) =>
                        setNewCourseJson(
                            e.target
                                .value
                        )
                    }
                    placeholder='Paste full course JSON here...'
                    className="w-full p-4 rounded-2xl bg-black/40 border border-white/20 font-mono text-sm"
                />

                <button
                    onClick={
                        handleAddCourse
                    }
                    className="mt-5 bg-orange-500 hover:bg-orange-600 transition-all px-6 py-3 rounded-xl font-medium"
                >
                    Add Course
                </button>


            </div>

            {/* COURSE LIST */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">

                {courses.map(
                    (
                        course,
                        index
                    ) => (

                        <div
                            key={index}
                            className="bg-white/5 border border-white/10 rounded-2xl p-5 hover:border-orange-500/40 transition-all"
                        >


                            {jsonEditingIndex === index ? (

                                <div className="space-y-4">

                                    <textarea
                                        rows={20}
                                        value={jsonEditingValue}
                                        onChange={(e) =>
                                            setJsonEditingValue(
                                                e.target.value
                                            )
                                        }
                                        className="w-full p-4 rounded-xl bg-black/40 border border-white/20 font-mono text-sm"
                                    />

                                    <div className="flex gap-3">

                                        <button
                                            onClick={() =>
                                                handleJsonUpdate(index)
                                            }
                                            className="flex-1 bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg"
                                        >
                                            Save JSON
                                        </button>

                                        <button
                                            onClick={() => {
                                                setJsonEditingIndex(null);
                                                setJsonEditingValue("");
                                            }}
                                            className="flex-1 bg-gray-600 hover:bg-gray-700 px-4 py-2 rounded-lg"
                                        >
                                            Cancel
                                        </button>

                                    </div>

                                </div>

                            ) : editingIndex === index ? (

                                <div className="space-y-4">

                                    <input
                                        type="text"
                                        value={
                                            editingValue
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setEditingValue(
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                        className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
                                    />

                                    <div className="flex gap-3">

                                        <button
                                            onClick={() =>
                                                handleUpdate(
                                                    index
                                                )
                                            }
                                            className="flex-1 bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg"
                                        >
                                            Save
                                        </button>

                                        <button
                                            onClick={() => {

                                                setEditingIndex(
                                                    null
                                                );

                                                setEditingValue(
                                                    ""
                                                );

                                            }}
                                            className="flex-1 bg-gray-600 hover:bg-gray-700 px-4 py-2 rounded-lg"
                                        >
                                            Cancel
                                        </button>

                                    </div>

                                </div>

                            ) : (

                                <>

                                    <div className="mb-4">

                                        <button
                                            onClick={() => handleCopyCourseJSON(course)}
                                            className="flex-1 bg-white/70 px-2 py-2 rounded-lg text-sm float-end"
                                        >
                                            <BsClipboardCheckFill color="black" size={17} />
                                        </button>

                                        <h3 className="text-lg font-semibold">
                                            {
                                                course.title
                                            }
                                        </h3>

                                        <p className="text-sm text-slate-400 mt-1">
                                            ID:
                                            {" "}
                                            {
                                                course.id
                                            }
                                        </p>

                                        <p className="text-sm text-slate-500 mt-1">
                                            {
                                                course.category
                                            }
                                        </p>

                                    </div>

                                    <div className="flex flex-wrap gap-3">

                                        <button
                                            onClick={() =>
                                                navigate(
                                                    `/dashboard/course-view?id=${course.id}`
                                                )
                                            }
                                            className="flex-1 bg-orange-500 hover:bg-orange-600 transition-all px-4 py-2 rounded-lg text-sm"
                                        >
                                            View
                                        </button>

                                        <button
                                            onClick={() =>
                                                handleEdit(
                                                    index,
                                                    course.title
                                                )
                                            }
                                            className="flex-1 bg-blue-600 hover:bg-blue-700 transition-all px-4 py-2 rounded-lg text-sm"
                                        >
                                            Edit
                                        </button>

                                        <button
                                            onClick={() =>
                                                handleJsonEdit(
                                                    index,
                                                    course
                                                )
                                            }
                                            className="flex-1 bg-purple-600 hover:bg-purple-700 transition-all px-4 py-2 rounded-lg text-sm"
                                        >
                                            JSON
                                        </button>

                                        <button
                                            onClick={() =>
                                                handleDelete(
                                                    index
                                                )
                                            }
                                            className="flex-1 bg-red-600 hover:bg-red-700 transition-all px-4 py-2 rounded-lg text-sm"
                                        >
                                            Delete
                                        </button>

                                    </div>

                                </>

                            )}


                            {/* {console.log(course.tiers)} */}

                            {course.tiers?.length > 0 && (
                                <div className="mt-3 space-y-3">
                                    {course.tiers.map((tier, i) => {
                                        const key = `${index}-${i}`;

                                        const current =
                                            tierEditing[key] || tier.price;

                                        return (
                                            <div
                                                key={i}
                                                className="bg-black/20 p-3 rounded-xl"
                                            >
                                                <h4 className="font-medium mb-3">
                                                    {tier.name}
                                                </h4>

                                                <div className="grid grid-cols-2 gap-2 mb-3">
                                                    <input
                                                        type="text"
                                                        placeholder="Offer"
                                                        value={current.offer || ""}
                                                        onChange={(e) =>
                                                            setTierEditing({
                                                                ...tierEditing,
                                                                [key]: {
                                                                    ...current,
                                                                    offer:
                                                                        e.target.value,
                                                                },
                                                            })
                                                        }
                                                        className="p-2 rounded-lg bg-black/40 border border-white/20 text-sm"
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Original"
                                                        value={current.original || ""}
                                                        onChange={(e) =>
                                                            setTierEditing({
                                                                ...tierEditing,
                                                                [key]: {
                                                                    ...current,
                                                                    original:
                                                                        e.target.value,
                                                                },
                                                            })
                                                        }
                                                        className="p-2 rounded-lg bg-black/40 border border-white/20 text-sm"
                                                    />
                                                </div>

                                                <button
                                                    onClick={() =>
                                                        handleTierUpdate(
                                                            index,
                                                            i
                                                        )
                                                    }
                                                    className="w-full bg-purple-600 hover:bg-purple-700 px-3 py-2 rounded-lg text-sm"
                                                >
                                                    Update {tier.name}
                                                </button>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}


                        </div>

                    )
                )}

            </div>

            {/* EMPTY */}
            {courses.length ===
                0 && (

                    <div className="bg-white/5 border border-dashed border-white/10 rounded-2xl p-10 text-center text-slate-400">

                        No courses
                        found

                    </div>

                )}

        </div>
    );
}